import { render, staticRenderFns } from "./TrashBank.vue?vue&type=template&id=4ab8cb56&"
import script from "./TrashBank.vue?vue&type=script&lang=js&"
export * from "./TrashBank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports